import { computed, reactive, ref, useContext } from '@nuxtjs/composition-api'
import { getApiErrorMessage } from '@/utils/orgToast'
import logger from '@/utils/logger'

const I18N = 'layouts.password_gate'
const MIN_PASSWORD_LENGTH = 8

/**
 * Гейт принудительной смены временного пароля (после приглашения сотрудника).
 * Пока user.mustChangePassword = true, бэк отвечает 403 на org-роуты,
 * поэтому после успешной смены страница перезагружается целиком.
 */
export function usePasswordChangeGate() {
  const { store, i18n } = useContext()

  const t = (key) => i18n.t(`${I18N}.${key}`)

  const visible = computed(() => store.getters['auth/mustChangePassword'])
  const loading = ref(false)
  const form = reactive({ newPassword: '', confirm: '' })
  const errors = reactive({ newPassword: '', confirm: '', submit: '' })

  function validate() {
    errors.newPassword = ''
    errors.confirm = ''
    errors.submit = ''

    if (form.newPassword.length < MIN_PASSWORD_LENGTH) {
      errors.newPassword = t('too_short')
    }

    if (form.confirm !== form.newPassword) {
      errors.confirm = t('mismatch')
    }

    return !errors.newPassword && !errors.confirm
  }

  async function submit() {
    if (loading.value || !validate()) return

    loading.value = true

    try {
      await store.dispatch('auth/setPassword', {
        newPassword: form.newPassword,
      })
      // Данные страницы под модалкой не загрузились (403) — перезагружаем целиком
      window.location.reload()
    } catch (error) {
      logger.error('Ошибка смены временного пароля:', error)
      errors.submit = getApiErrorMessage(error, t('error'))
    } finally {
      loading.value = false
    }
  }

  return { t, visible, loading, form, errors, submit }
}
